// extracted by mini-css-extract-plugin
export default {"App":"App_App__3lnFj","appLogo":"App_appLogo__HT6IG","profileLogo":"App_profileLogo__VdTk1","authMain":"App_authMain__-iFPM","main":"App_main__QgiQl"};